import axios from 'axios';
import { API_BASE_URL } from '../../config';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

const credentialService = {
  getAll: () => {
    return api.get('/credentials');
  },

  getById: (id) => {
    return api.get(`/credentials/${id}`);
  },

  create: (credential) => {
    return api.post('/credentials', credential);
  },

  update: (id, credential) => {
    return api.put(`/credentials/${id}`, credential);
  },

  delete: (id) => {
    return api.delete(`/credentials/${id}`);
  },

  getCountsByApp: () => {
    return api.get('/credentials/counts-by-app');
  }
};

export default credentialService;
